module.exports = __webpack_public_path__ + "img/car_empty.f83233e8.png";